import React from 'react';

import data from './extra-infs-data.json';


import './extra-infs.css';

const ExtraInformationSources = ()=>{


  const columns=[
    'Topic',
    'Website',
    'Info',
    'Link',
  ]




  // const totalCols = columns.length;

  const ths = columns.map(elem=><th className="background-default2" key={elem}>{elem}</th>);

  const totalCols=columns.length;


  const classZebra='extra-source-zebra-class';
  let applyZebra='';

  const tableBody=data.map((elem,index)=>{
    const {mainTitle,category,topics}=elem;

    applyZebra = applyZebra ? '' : classZebra;

    // main title
    if(mainTitle) {
      return (
        <tr className={applyZebra} key={'extra-inf-'+index}>
          <td className="extra-source-inf-main-title" colSpan={totalCols}>{mainTitle}</td>
        </tr>
      )
    }





    const topicsTds=topics.map((elem)=>{
      const {topic,info,link}=elem;
      return [
        <td className="extra-source-inf-topic" key={'extra-inf-topic-topic'+index}>{topic}</td>,
        <td key={'extra-inf-topic-info'+index}>{info}</td>,
        <td key={'extra-inf-topic-link'+index}>{link}</td>,
      ]
    });

    const topicsQtd=topics.length;

    const first=topicsTds.splice(0,1);

    const ret=topicsTds.map((elem,index)=>{
      return <tr className={applyZebra} key={'extra-inf-topic-row-'+index}>{elem}</tr>
    });

    const categoryHtml=(
      <tr className={applyZebra} key={'extra-inf-'+index}><td className="extra-source-inf-category" rowSpan={topicsQtd}>{category}</td>{first}</tr>
    )

    ret.unshift(categoryHtml);

    return ret;

  });



  return (
    <div className="background-default1 page-content">
      <h2 className="page-title">Extra Information Source</h2>
      <h2 className="page-main-title font-color2">Extra Information Source</h2>
      {/* <p className="page-top-descr font-color2">Check the definition of each topic our system provides automatically:</p> */}
      <div className="extra-source-inf">
        <table cellSpacing="0">
          <thead>
            <tr>{ths}</tr>
          </thead>
          <tbody>
            {tableBody}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default ExtraInformationSources;